import * as fb from '../../firebase'
import * as firebase from 'firebase/app'

export default {
  namespaced: true,
  
  state: {
    categories: ['wins', 'improves'],
    winsimproves: {},
    winslist: [],
  },
  /* ================================================================ */
  mutations: {
    setWinsImproves(state, payload) {
      if (payload['key']) {
        const category = payload['key'];
        state.winsimproves[category] = payload['data']
        state.winsimproves['date']=payload['date']
      }
      else {
        state.winsimproves['date']=payload['date']
        state.winsimproves=payload['data']
      }
    },
    /**
     * Delete record matching given date
     */
    deleteWinsImproves(state, payload) {
      if (payload.date == state.winsimproves.date) {
        state.winsimproves={}
      }
    },
    //
    setWinsList(state, payload) {
      if (Array.isArray(payload)) {
        state.winslist=payload;
      }
    },
    //
    updateWinsList(state, payload) {
      if (!Array.isArray(state.winslist)) {
        state.winslist=[]
      }
      state.winslist.push(payload.date)
    },
    //
    deleteWinListItem(state, payload) {
      state.winslist=state.winslist.filter(date => date!=payload.date)
    }
  },
/* ================================================================ */
  actions: {
    async saveWinsImproves({dispatch, commit }, payload) {
      //payload['key'] is either "wins" or "improves"
      await fb.winsCollection.doc(fb.auth.currentUser.uid).collection('wins').doc(payload.date).set({ [payload['key']]: payload['data'] }, { merge: true })
        .then(() => {
          commit('setWinsImproves', payload)
          dispatch('saveWinsListItem', payload)
        })
        .catch(error => {
          console.log('Error while saving wins:', error)
        })
    },

    async fetchWinsImproves({ commit }, payload) {
      await fb.winsCollection.doc(fb.auth.currentUser.uid).collection('wins').doc(payload.date).get()
        .then((doc) => {
          if (doc.exists && doc.data()) {
            commit('setWinsImproves', {date: payload.date, data: doc.data()})
          }
        })
        .catch(error => {
          console.log('Error while fetching wins:', error)
        })
    },

    async saveWinsListItem({ state, dispatch }, payload) {
      //Check if payload.date already in winslist
      if (Array.isArray(state.winslist) && state.winslist.length > 0) {
        const found = state.winslist.find(date => date == payload.date)
        if (found) { return; }
        //Update winslist on server
        dispatch('updateWinsList', payload)
      }
      else {
        await fb.winsCollection.doc(fb.auth.currentUser.uid).collection('wins').doc('winslist').get().then(doc => {
          if (!doc.exists || !doc.data()) {
            //Create new winslist and add first element
            dispatch('createWinsList', payload);
          }
          else {
            dispatch('updateWinsLis', payload)
          }
        }).catch(error => {
          console.log('Error retrieving winslist:', error)
        })

      }
    },

    async createWinsList({ commit }, payload) {
      await fb.winsCollection.doc(fb.auth.currentUser.uid).collection('wins').doc('winslist').set({ 'wins': [payload.date] })
        .then(() => {
          commit('updateWinsList', payload)
        })
        .catch(error => {
          console.log('Error while creating winslist:', error)
        })
    },

    async updateWinsList({commit }, payload) {
      await fb.winsCollection.doc(fb.auth.currentUser.uid).collection('wins').doc('winslist').update({ 'wins': firebase.firestore.FieldValue.arrayUnion(payload.date) })
        .then(() => {
          commit('updateWinsList', payload)
        })
        .catch(error => {
          console.log('Error while updating winslist:', error)
        })
    },

    async fetchWinsList({state, commit }) {
      //State winslist already downloaded once
      if (state.winslist.length > 1) { return; }
      
      await fb.winsCollection.doc(fb.auth.currentUser.uid).collection('wins').doc('winslist').get()
        .then( doc => {
          if (doc.exists && doc.data()) {
            commit('setWinsList', doc.data()['wins'])
          }
        })
        .catch(error => {
          console.log('Error while retrieving winslist', error)
        })
    },

    async deleteWinsImproves({ commit, dispatch }, payload) {
      await fb.winsCollection.doc(fb.auth.currentUser.uid).collection('wins').doc(payload.date).delete()
        .then(() => {
          commit('deleteWinsImproves', payload)
          dispatch('deleteWinListItem', payload)
        })
        .catch(error => {
          console.log('Error while deleting wins:', error)
        })
    },

    async deleteWinListItem({ commit }, payload) {
      await fb.winsCollection.doc(fb.auth.currentUser.uid).collection('wins').doc('winslist').update({ 'wins': firebase.firestore.FieldValue.arrayRemove(payload.date) })
        .then(() => {
          commit('deleteWinListItem', payload)
        })
        .catch(error => {
          console.log('Error while deleting winslist item', error)
        })
    },

  },
/* ================================================================ */
  getters: {
    getDisplayDate(year, month, date) {
      if(isNaN(year) || isNaN(month) || isNaN(date)) {
        const curDate = new Date();
        year = curDate.getFullYear();
        //getMonth returns an Integer: 0-11
        month = curDate.getMonth();
        date = curDate.getDate();
      }

      month = (parseInt(month) + 1).toString().padStart(2, '0');
      date = parseInt(date).toString().padStart(2, '0');

      return year + '-' + month + '-' + date;
    }
  }
}
